import { Fragment } from "react";
import { Box, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TokenLogo from "../TokenLogo";

// the route of a swap: each token it passes through, in order
const SwapRoute = ({ path, tokenSend, tokenReceived }) => {
  if (!path || path.length < 2) return null;
  const tokens = path.map((token, index) =>
    index === 0 ? tokenSend : index === path.length - 1 ? tokenReceived : token
  );
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1.5 }}>
      <Typography variant="body2" component="span" sx={{ color: "text.secondary" }}>
        Route
      </Typography>
      <Box
        component="ol"
        aria-label={`Route: ${tokens.map((token) => token.symbol).join(", ")}`}
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          justifyContent: "flex-end",
          gap: 0.5,
          m: 0,
          p: 0,
          listStyle: "none",
        }}
      >
        {tokens.map((token, index) => (
          <Fragment key={`${token.address}-${index}`}>
            {index > 0 ? <ChevronRightIcon aria-hidden sx={{ fontSize: 18, color: "text.secondary" }} /> : null}
            <Box component="li" sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <TokenLogo token={token} size={18} />
              <Typography variant="body2" component="span">
                {token.symbol}
              </Typography>
            </Box>
          </Fragment>
        ))}
      </Box>
    </Box>
  );
};

export default SwapRoute;
